import styled from 'styled-components'
import getBreakpoint from '@client/utils/breakpoints'
import * as HomeStyle from '../../Home.style'

export const Title = styled(HomeStyle.Title)`
  margin-bottom: 32px;

  @media (min-width: ${getBreakpoint('xl')}px) {
    font-size: 32px;
    line-height: 38px;
    margin-bottom: 40px;
    text-align: center;
  }
`

export const GymsWrapper = styled.section`
  padding-top: 24px;
  background-color: var(--white);
`

export const MapWrapper = styled.section`
  height: 606px;
`
